import {
  PDFActivityPlanInfoItem,
  PDFActivityPlanInfoWrapper,
  PDFDocumentLetterhead,
  PDFProgression
} from 'components/PDFDocuments/PDFDocument';
import React from 'react';
import { ActivityPlan, Progression } from 'types/activityPlan';
import { DraftActivityPlan, DraftProgression } from 'types/draftActivityPlan';
import { ProgressionTypes } from 'utils/activityPlan';
import { extractProgramInfoFromUri } from 'utils/extractProgramInfoFromUri';
import { Programs } from 'utils/programConstants';

interface Props {
  activityPlan: ActivityPlan | DraftActivityPlan | undefined;
}

export const ChronicConfigPDFDocument = ({
  activityPlan
}: Props): JSX.Element | null => {
  if (!activityPlan) {
    return null;
  }

  const { uri, name, progressions } = activityPlan;
  const { indication, stream } = extractProgramInfoFromUri(uri);
  const pdfProgressions: JSX.Element[] = [];
  progressions.forEach((progression: Progression | DraftProgression) => {
    pdfProgressions.push(
      <PDFProgression
        progression={progression}
        type={ProgressionTypes[Programs.CHRONIC]}
        key={progression.uuid}
      />
    );
  });

  return (
    <PDFDocumentLetterhead title={name ?? `Chronic ${indication} - ${stream}`}>
      <PDFActivityPlanInfoWrapper>
        <PDFActivityPlanInfoItem text="Program: Chronic" />
        <PDFActivityPlanInfoItem text={`Indication: ${indication}`} />
        <PDFActivityPlanInfoItem text={`Activity Stream: ${stream}`} />
      </PDFActivityPlanInfoWrapper>
      {pdfProgressions}
    </PDFDocumentLetterhead>
  );
};
